import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule} from 'primeng/accordion';
import { TableModule} from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import {ConfirmationService} from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { UpdateMinuteComponent } from './update/update-minute.component';
import { ViewMinuteComponent } from './view/view-minutes.component';
import { LoginRouteGuard } from 'src/app/login-route-guard';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AccordionModule,
    TableModule,
    ToastModule,
    ConfirmDialogModule,
    // ProgressSpinnerModule,
    RouterModule.forChild([
      { path: 'updateminutes', component: UpdateMinuteComponent, canActivate: [LoginRouteGuard] },
      { path: 'viewminutes', component: ViewMinuteComponent, canActivate: [LoginRouteGuard]},
      { path: '', redirectTo: 'home', pathMatch: 'full'},
    ]),

  ],
  declarations: [
    UpdateMinuteComponent,
    ViewMinuteComponent,
  ],
  providers: [
    MessageService,
    ConfirmationService,
  ]
})
export class MinutesModule { }
